import { render, staticRenderFns } from "./form.vue?vue&type=template&id=ee8f93b6&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8f93b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee8f93b6')) {
      api.createRecord('ee8f93b6', component.options)
    } else {
      api.reload('ee8f93b6', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=ee8f93b6&scoped=true", function () {
      api.rerender('ee8f93b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/third-party/components/form.vue"
export default component.exports